<template lang="pug">

  .lesson-test-slide-answers-answer
    .lesson-test-slide-answers-answer__header(
      :class="{'-numbers-opened-': numbersIsOpen}"
    )
      .lesson-test-slide-answers-answer__header-left
        .lesson-test-slide-answers-answer__checkbox(
          @click="toggleCheckbox"
        )
          CheckboxBlock(
            :value="answer.isCorrect"
            :disabled="true"
            :wrapperClass="isMultipleAnswers && '-rect-'"
          )

        Input.lesson-test-slide-answers-answer__input(
          v-model="answer.text"
          placeholder="Введите ответ"
          :showIcon="false"
          @focus="addAnswer"
          @blur="deleteAnswer"
          @input="updateAnswer"
        )

      .lesson-test-slide-answers-answer__header-right
        .lesson-test-slide-answers-answer__points
          Input(
            v-model="answer.points"
            :show-icon="false"
            type="number"
            @input="updateAnswer"
          )
        .lesson-test-slide-answers-answer__arrow(
          @click="numbersIsOpen = !numbersIsOpen"
          :class="{'-active-': numbersIsOpen}"
        )
          Icon(icon="slider-arrow-next")

    SlideUpDown.lesson-test-slide-answers-answer__slider(
      :duration="200"
      :active="numbersIsOpen"
    )
      .lesson-test-slide-answers-answer-numbers
        .lesson-test-slide-answers-answer-numbers__item(
          v-for="(value, key) in answer.numbers" :key="key"
        )
          .lesson-test-slide-answers-answer-numbers__icon(
            v-if="key !== 'romi' && key !== 'nps'"
            v-tiny-text-tooltip="{text: getNumberText(key)}"
          )
            Icon(:icon="getNumberIcon(key)")
          .lesson-test-slide-answers-answer-numbers__title(
            v-else
          )
            | {{ key }}:
          .lesson-test-slide-answers-answer-numbers__input
            Input(
              v-model="answer.numbers[key]"
              :show-icon="false"
              type="number"
              @input="updateAnswer"
            )

</template>

<script>
import _ from 'lodash';
import CheckboxBlock from '@/components/Form/Checkbox';
import SlideUpDown from 'vue-slide-up-down';

export default {
  components: { CheckboxBlock, SlideUpDown },
  props: ['propAnswer', 'isMultipleAnswers', 'lastAnswer'],
  data: () => ({
    answer: {
      text: '',
      isCorrect: false,
      points: 0
    },
    mounted: false,
    numbersIsOpen: false
  }),
  watch: {
    propAnswer: {
      deep: true,
      handler() {
        this.setData();
      }
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.answer = _.cloneDeep(this.propAnswer);
    },
    deleteAnswer() {
      if (!this.answer.text) {
        this.$emit('deleteAnswer');
      }
    },
    addAnswer() {
      if (this.lastAnswer) {
        this.$emit('addAnswer');
      }
    },
    toggleCheckbox() {
      this.answer.isCorrect = !this.answer.isCorrect;
      this.updateAnswer();
    },
    updateAnswer() {
      this.$emit('updateAnswer', this.answer);
    },
    getNumberIcon(key) {
      switch (key) {
        case 'money':
          return 'purse';
        case 'deals':
          return 'deal';
        case 'analytics':
          return 'analytics';
        case 'marketing':
          return 'marketing';
        case 'sales':
          return 'deal';
        case 'team':
          return 'user-group';
        default:
          return '';
      }
    },
    getNumberText(key) {
      switch (key) {
        case 'money':
          return 'Деньги';
        case 'deals':
          return 'Сделки';
        case 'analytics':
          return 'Аналитика';
        case 'marketing':
          return 'Маркетинг';
        case 'sales':
          return 'Продажи';
        case 'team':
          return 'Команда';
        default:
          return '';
      }
    }
  }
};
</script>
